"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var Payment_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Payment = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const uuid_1 = require("uuid");
const PaymentStatus_1 = require("../domain/PaymentStatus");
const PaymentTargetEntity_1 = require("../domain/PaymentTargetEntity");
const PaymentType_1 = require("../domain/PaymentType");
const statusGetter_1 = require("../statusGetter");
const transformToDate_1 = require("../transformers/transformToDate");
const NethoneDetails_1 = require("./NethoneDetails");
const PaymentMangopayInformation_1 = require("./PaymentMangopayInformation");
let Payment = Payment_1 = class Payment {
    _id = (0, uuid_1.v4)();
    createdAt = new Date();
    userId;
    amount;
    currency = legacy_enums_1.Currency.Euro;
    type;
    description;
    gatewayId;
    cardholderName;
    cardAlias;
    cardCountryId;
    orderId = null;
    paymentRequestId = null;
    poolOfferId;
    targetEntity;
    bundleId;
    fulfilledAt;
    chargedBackAt;
    failedAt;
    isPreparedToPayout = false;
    isPaidOut = false;
    isRecord = false;
    mangopay;
    setupIntentId; // only for stripe payments
    instrumentId; // only for checkout payments
    preAuthorizedAt;
    uncapturedAt;
    cancelledAt;
    isManuallyFailed;
    isApplePay;
    isGooglePay;
    isAlipay;
    // TODO: remove checkoutNewPlatformPayment once old platform is stopped
    checkoutNewPlatformPayment;
    nethone;
    countryISOOfResidence;
    originalPreauthorizedAmount;
    get status() {
        return (0, statusGetter_1.statusGetter)(this, Payment_1, PaymentStatus_1.PaymentStatus);
    }
    static statusPrototype(status) {
        const defined = new Date();
        switch (status) {
            case PaymentStatus_1.PaymentStatus.Failed:
                return {
                    failedAt: defined,
                };
            case PaymentStatus_1.PaymentStatus.Cancelled:
                return {
                    cancelledAt: defined,
                };
            case PaymentStatus_1.PaymentStatus.Fulfilled:
                return {
                    failedAt: undefined,
                    fulfilledAt: defined,
                    chargedBackAt: undefined,
                };
            case PaymentStatus_1.PaymentStatus.ChargedBack:
                return {
                    failedAt: undefined,
                    fulfilledAt: defined,
                    chargedBackAt: defined,
                };
            case PaymentStatus_1.PaymentStatus.PreAuthorized:
                return {
                    preAuthorizedAt: defined,
                    fulfilledAt: undefined,
                    failedAt: undefined,
                    cancelledAt: undefined,
                    chargedBackAt: undefined,
                };
            case PaymentStatus_1.PaymentStatus.Uncaptured:
                return {
                    preAuthorizedAt: undefined,
                    fulfilledAt: undefined,
                    failedAt: undefined,
                    chargedBackAt: undefined,
                    cancelledAt: undefined,
                    uncapturedAt: defined,
                };
            case PaymentStatus_1.PaymentStatus.Pending:
            default:
                return {
                    failedAt: undefined,
                    fulfilledAt: undefined,
                    chargedBackAt: undefined,
                    preAuthorizedAt: undefined,
                    uncapturedAt: undefined,
                    cancelledAt: undefined,
                };
        }
    }
};
exports.Payment = Payment;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payment.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payment.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payment.prototype, "userId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Payment.prototype, "amount", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Object)
], Payment.prototype, "currency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], Payment.prototype, "type", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((p) => p.type === PaymentType_1.PaymentType.Other),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payment.prototype, "description", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payment.prototype, "gatewayId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.ValidateIf)((p) => p.type === PaymentType_1.PaymentType.Mangopay),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payment.prototype, "cardholderName", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.ValidateIf)((p) => p.type === PaymentType_1.PaymentType.Mangopay),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payment.prototype, "cardAlias", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.ValidateIf)((p) => p.type === PaymentType_1.PaymentType.Mangopay),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payment.prototype, "cardCountryId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((p) => p.paymentRequestId == null && p.poolOfferId == null),
    (0, class_transformer_1.Transform)(({ value }) => (value == null ? undefined : value)),
    __metadata("design:type", Object)
], Payment.prototype, "orderId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((p) => p.orderId == null && p.poolOfferId == null),
    __metadata("design:type", Object)
], Payment.prototype, "paymentRequestId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateIf)((p) => p.orderId == null && p.paymentRequestId == null),
    (0, class_transformer_1.Transform)(({ value }) => (value == null ? undefined : value)),
    __metadata("design:type", String)
], Payment.prototype, "poolOfferId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsEnum)(PaymentTargetEntity_1.PaymentTargetEntity),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payment.prototype, "targetEntity", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.ValidateIf)((p) => p.targetEntity === PaymentTargetEntity_1.PaymentTargetEntity.OrderBundle),
    __metadata("design:type", String)
], Payment.prototype, "bundleId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payment.prototype, "fulfilledAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payment.prototype, "chargedBackAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payment.prototype, "failedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Payment.prototype, "isPreparedToPayout", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Payment.prototype, "isPaidOut", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Boolean)
], Payment.prototype, "isRecord", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => PaymentMangopayInformation_1.PaymentMangopayInformation),
    __metadata("design:type", PaymentMangopayInformation_1.PaymentMangopayInformation)
], Payment.prototype, "mangopay", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payment.prototype, "setupIntentId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], Payment.prototype, "instrumentId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payment.prototype, "preAuthorizedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payment.prototype, "uncapturedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], Payment.prototype, "cancelledAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], Payment.prototype, "isManuallyFailed", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], Payment.prototype, "isApplePay", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], Payment.prototype, "isGooglePay", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], Payment.prototype, "isAlipay", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsBoolean)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Boolean)
], Payment.prototype, "checkoutNewPlatformPayment", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsObject)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", NethoneDetails_1.NethoneDetails)
], Payment.prototype, "nethone", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], Payment.prototype, "countryISOOfResidence", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", Number)
], Payment.prototype, "originalPreauthorizedAmount", void 0);
__decorate([
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], Payment.prototype, "status", null);
exports.Payment = Payment = Payment_1 = __decorate([
    (0, type_graphql_1.ObjectType)("Payment"),
    (0, typeorm_1.Entity)("payments")
], Payment);
//# sourceMappingURL=Payment.js.map